import showView from "../views/index";
import AppEvent from '../helpers/appEvent' 

const yaTiene = () => {
    showView('TIENE_DEUDA')
    AppEvent.sendEvent('TIENE_DEUDA');
}

export default yaTiene;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/tieneDeuda.js